import { render, staticRenderFns } from "./ProgressLoader.vue?vue&type=template&id=28e97f56&scoped=true&"
import script from "./ProgressLoader.vue?vue&type=script&lang=js&"
export * from "./ProgressLoader.vue?vue&type=script&lang=js&"
import style0 from "./ProgressLoader.vue?vue&type=style&index=0&id=28e97f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e97f56",
  null
  
)

export default component.exports